// authority.js
export default {
    forum_name: 'Forum Name',
    search: 'Search',
    reset: 'Reset',
    status_closed: 'Closed',
    status_open: 'Open',
    index: 'Index',
    name: 'Forum Name',
    status: 'Status',
    conduct_time: 'Conduct Time',
    founder: 'Founder',
    action: 'Action',
    permission: 'Permission',
    confirm_delete: 'Are you sure to delete this forum?',
    delete_success: 'Delete successful',
    operation_success: 'Operation successful',
    input_forum_name: 'Please enter the forum name',
    add_admin: 'Add Administrator',
    edit: 'Edit',
    data_permission: 'Data Permission',
    delete: 'Delete',
    confirm_content: 'Are you sure to delete this administrator?',
    user_id: 'User ID',
    real_name: 'User Name',
    organization: 'Organization',
    email: 'User Email',
    mobile: 'User Mobile',
    role_name: 'Role Name',
    ticket: 'Ticket',
    select_all: 'Select All',
    article: 'Article',
    set_success: 'Set successfully',
    address: 'Forum Address',
    to: 'To',
    admin_edit_title: 'Edit Administrator',
    add_admin_title: 'Add Administrator',
    email_or_phone: 'Email/Phone Number',
    input_email_or_phone: 'Please enter an email number or phone number to find the user',
    name_label: 'Name',
    input_name: 'Please enter a name',
    organization_label: 'Organization',
    input_organization: 'Please enter an organization',
    backend_role: 'Conference Backend Role',
    select_backend_role: 'Please select a conference backend role',
    permission_label: 'Permission:',
    all: 'All',
    select_all_label: 'Select All',
    custom: 'Custom',
    select_permission_label: 'Please select routing permissions'
};
